import { render, staticRenderFns } from "./TerritoryContactProfile.vue?vue&type=template&id=70bd5255&scoped=true&"
import script from "./TerritoryContactProfile.vue?vue&type=script&lang=js&"
export * from "./TerritoryContactProfile.vue?vue&type=script&lang=js&"
import style0 from "./TerritoryContactProfile.vue?vue&type=style&index=0&id=70bd5255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70bd5255",
  null
  
)

export default component.exports